export const propertySpecials = ['$scope', function ($scope) {
    $scope.filters = {
        region: '',
        type: ''
    }
    $scope.setFilter = function (filter) {
        $scope.filters = filter ? Object.assign({}, $scope.filters, filter ) : {}
        document.querySelector('.c-offers-container').scrollIntoView()
    }
}]
